import { useOpenOffer } from 'app/hooks/use-open-offer';
import { useNavigation } from '@react-navigation/native';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { ListingType } from 'app/types/listing';
import { type SpecificNavigationProp } from 'app/types/navigation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

const TIPS: {
  key: 'publishRequest' | 'browseCatalog' | 'helpNeighbours' | 'publishOffer';
  emoji: string;
  navigation: (nav: SpecificNavigationProp<'streak'>, openOffer: ReturnType<typeof useOpenOffer>) => void;
}[] = [
  {
    key: 'publishRequest',
    emoji: '👋',
    navigation: (nv) =>
      nv.navigate(
        'new',
        {
          defaultValues: { type: ListingType.request },
          newListingSource: 'streak_tip',
        },
        { pop: true },
      ),
  },
  { key: 'browseCatalog', emoji: '🔍', navigation: (nv) => nv.navigate('billboard', { screen: 'all-listings' }) },
  { key: 'helpNeighbours', emoji: '👋', navigation: (nv) => nv.navigate('billboard', { screen: 'all-listings' }) },
  {
    key: 'publishOffer',
    emoji: '🫴',
    navigation: (nv, openOffer) => openOffer(nv, { newListingSource: 'streak_tip' }),
  },
];

export const TipsCard = function TipsCard() {
  const { t } = useTranslation('streak');
  const openOffer = useOpenOffer();
  const navigation = useNavigation<SpecificNavigationProp<'streak'>>();

  return (
    <Column
      backgroundColor="white"
      borderRadius="radius.lg"
      padding="spacing.general.x4"
      gap="spacing.general.x4"
      borderWidth={1}
      borderColor="surface.disabled"
    >
      {TIPS.map((tip, idx) => (
        <React.Fragment key={tip.key}>
          {idx > 0 ? <Column height={1} backgroundColor="surface.disabled" marginBottom="spacing.general.x4" /> : null}
          <Pressable onPress={() => tip.navigation(navigation, openOffer)}>
            <Row alignItems="flex-start" gap="spacing.general.x4">
              <Column
                alignItems="center"
                backgroundColor="surface.brand.secondary-5.default"
                borderRadius="radius.xxl"
                height={40}
                justifyContent="center"
                width={40}
              >
                <Text fontSize={20}>{tip.emoji}</Text>
              </Column>
              <Column flex={1} gap="spacing.general.x0,5">
                <Text fontSize={15} fontWeight="bold">
                  {t(`tips.${tip.key}.title`)}
                </Text>
                <Text color="text.tertiary" fontSize={13}>
                  {t(`tips.${tip.key}.description`)}
                </Text>
              </Column>
            </Row>
          </Pressable>
        </React.Fragment>
      ))}
    </Column>
  );
};
